(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function normalizeText(value) {
    return value.replace(/\s+/g, ' ').trim();
  }

  function slugify(value) {
    return normalizeText(value)
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'policy-section';
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function normalizeLegacyFlow(rte) {
    var hasDirectHeadings = Array.prototype.some.call(rte.children, function (child) {
      return child.tagName === 'STRONG';
    });

    if (!hasDirectHeadings) return;

    var fragment = document.createDocumentFragment();
    var paragraph = null;

    function flushParagraph() {
      if (!paragraph) return;
      if (normalizeText(paragraph.textContent)) fragment.appendChild(paragraph);
      paragraph = null;
    }

    Array.prototype.slice.call(rte.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && !normalizeText(node.textContent)) return;

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'STRONG') {
        flushParagraph();
        var heading = element('h2', 'policy-generated-heading', normalizeText(node.textContent));
        fragment.appendChild(heading);
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        flushParagraph();
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE && /^(P|H[1-6]|UL|OL|TABLE|BLOCKQUOTE|DIV)$/.test(node.tagName)) {
        flushParagraph();
        fragment.appendChild(node);
        return;
      }

      if (!paragraph) paragraph = document.createElement('p');
      paragraph.appendChild(node);
    });

    flushParagraph();
    rte.replaceChildren(fragment);
  }

  function promoteParagraphHeadings(rte) {
    Array.prototype.slice.call(rte.querySelectorAll(':scope > p')).forEach(function (paragraph) {
      var text = normalizeText(paragraph.textContent);
      var onlyStrong = paragraph.children.length === 1 &&
        paragraph.firstElementChild.tagName === 'STRONG' &&
        normalizeText(paragraph.firstElementChild.textContent) === text;

      if (!onlyStrong || text.length > 90 || !/:$/.test(text)) return;

      var heading = element('h2', 'policy-generated-heading', text.replace(/:$/, ''));
      paragraph.replaceWith(heading);
    });
  }

  function prepareHeadings(rte, pageTitle) {
    Array.prototype.slice.call(rte.querySelectorAll(':scope > h1')).forEach(function (heading) {
      if (normalizeText(heading.textContent).toLowerCase() === normalizeText(pageTitle).toLowerCase()) {
        heading.remove();
      } else {
        var replacement = element('h2', '', normalizeText(heading.textContent));
        heading.replaceWith(replacement);
      }
    });

    var usedIds = {};
    return Array.prototype.slice.call(rte.querySelectorAll('h2, h3')).map(function (heading) {
      var baseId = heading.id || slugify(heading.textContent);
      var id = baseId;
      var suffix = 2;

      while (usedIds[id] || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = baseId + '-' + suffix;
        suffix += 1;
      }

      usedIds[id] = true;
      heading.id = id;
      heading.classList.add('policy-section-heading');
      return heading;
    });
  }

  function removeLegacyContents(rte) {
    var firstList = rte.querySelector(':scope > ul');
    if (!firstList) return;

    var links = Array.prototype.slice.call(firstList.querySelectorAll('a'));
    if (links.length > 1 && links.every(function (link) { return link.getAttribute('href').charAt(0) === '#'; })) {
      firstList.remove();
    }
  }

  function createContents(headings, className) {
    var nav = element('nav', className);
    nav.setAttribute('aria-label', 'On this page');
    var list = element('ol', 'policy-contents__list');

    headings.forEach(function (heading) {
      var item = element('li', heading.tagName === 'H3' ? 'policy-contents__item policy-contents__item--nested' : 'policy-contents__item');
      var link = element('a', 'policy-contents__link', normalizeText(heading.textContent));
      link.href = '#' + heading.id;
      item.appendChild(link);
      list.appendChild(item);
    });

    nav.appendChild(list);
    return nav;
  }

  function enhancePolicyPage() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container || container.dataset.policyEnhanced === 'true') return;

    var titleWrapper = container.querySelector('.shopify-policy__title');
    var body = container.querySelector('.shopify-policy__body');
    var rte = body && body.querySelector('.rte');
    var title = titleWrapper && titleWrapper.querySelector('h1');
    if (!titleWrapper || !body || !rte || !title) return;

    container.dataset.policyEnhanced = 'true';
    container.classList.add('policy-page', 'is-enhanced');

    var pageTitle = normalizeText(title.textContent);
    var policyKey = window.location.pathname.split('/').filter(Boolean).pop() || 'policy';
    container.dataset.policy = policyKey;

    var descriptions = {
      'shipping-policy': 'Clear delivery options, order handling, and shipping safeguards in one place.',
      'refund-policy': 'Warranty, return, repair, and cancellation terms in one place.',
      'privacy-policy': 'How we collect, use, and protect information you share with us.',
      'terms-of-service': 'The terms that govern use of Two Way Radio Gear and our services.',
      'contact-information': 'Verified business contact information for Two Way Radio Gear, Inc.'
    };

    var updatedNode = Array.prototype.find.call(rte.querySelectorAll(':scope > p'), function (paragraph) {
      return /^last updated\s*:/i.test(normalizeText(paragraph.textContent));
    });
    var updatedText = updatedNode ? normalizeText(updatedNode.textContent) : '';
    if (updatedNode) updatedNode.remove();

    normalizeLegacyFlow(rte);
    promoteParagraphHeadings(rte);
    removeLegacyContents(rte);
    var headings = prepareHeadings(rte, pageTitle);

    var hero = element('section', 'policy-hero');
    var heroInner = element('div', 'policy-wrap policy-hero__inner');
    var breadcrumbs = element('nav', 'policy-breadcrumbs');
    breadcrumbs.setAttribute('aria-label', 'Breadcrumb');
    var breadcrumbList = element('ol', 'policy-breadcrumbs__list');
    var homeItem = element('li', 'policy-breadcrumbs__item');
    var homeLink = element('a', '', 'Home');
    homeLink.href = '/';
    homeItem.appendChild(homeLink);
    var policiesItem = element('li', 'policy-breadcrumbs__item', 'Policies');
    var currentItem = element('li', 'policy-breadcrumbs__item', pageTitle);
    currentItem.setAttribute('aria-current', 'page');
    breadcrumbList.append(homeItem, policiesItem, currentItem);
    breadcrumbs.appendChild(breadcrumbList);

    var eyebrow = element('p', 'policy-hero__eyebrow', 'Customer care & policies');
    title.className = 'policy-hero__title';
    var lede = element('p', 'policy-hero__lede', descriptions[policyKey] || 'Official store information from Two Way Radio Gear.');
    var meta = element('div', 'policy-hero__meta');
    meta.appendChild(element('span', 'policy-trust-badge', 'Official store policy'));
    meta.appendChild(element('span', 'policy-trust-badge', 'US-based support'));
    if (updatedText) meta.appendChild(element('span', 'policy-hero__updated', updatedText));

    heroInner.append(breadcrumbs, eyebrow, title, lede, meta);
    hero.appendChild(heroInner);
    titleWrapper.remove();
    container.insertBefore(hero, body);

    var contentSection = element('div', 'policy-content');
    var contentInner = element('div', 'policy-wrap policy-layout');
    var mainColumn = element('div', 'policy-main');
    var article = element('article', 'policy-card');
    article.setAttribute('aria-label', pageTitle + ' details');
    article.appendChild(rte);
    mainColumn.appendChild(article);

    if (headings.length) {
      var aside = element('aside', 'policy-sidebar');
      var asideCard = element('div', 'policy-sidebar__card');
      asideCard.appendChild(element('p', 'policy-contents__title', 'On this page'));
      asideCard.appendChild(createContents(headings, 'policy-contents policy-contents--desktop'));
      aside.appendChild(asideCard);
      contentInner.appendChild(aside);

      var mobileContents = element('details', 'policy-mobile-contents');
      var summary = element('summary', 'policy-mobile-contents__summary', 'On this page');
      mobileContents.append(summary, createContents(headings, 'policy-contents policy-contents--mobile'));
      mainColumn.insertBefore(mobileContents, article);
    } else {
      contentInner.classList.add('policy-layout--single');
    }

    var utility = element('section', 'policy-utility');
    utility.setAttribute('aria-label', 'Policy help and related information');
    var help = element('div', 'policy-help');
    var helpCopy = element('div', 'policy-help__copy');
    helpCopy.append(
      element('p', 'policy-help__eyebrow', 'Need clarification?'),
      element('h2', 'policy-help__title', 'Talk with our support team'),
      element('p', 'policy-help__text', 'Get help understanding an order, return, delivery, or account question.')
    );
    var helpLink = element('a', 'policy-help__link', 'Contact us');
    helpLink.href = '/pages/contact-us';
    help.append(helpCopy, helpLink);

    var related = element('div', 'policy-related');
    related.appendChild(element('p', 'policy-related__title', 'Related policies'));
    var relatedList = element('div', 'policy-related__links');
    [
      ['Shipping', '/policies/shipping-policy', 'shipping-policy'],
      ['Returns & refunds', '/policies/refund-policy', 'refund-policy'],
      ['Privacy', '/policies/privacy-policy', 'privacy-policy'],
      ['Terms', '/policies/terms-of-service', 'terms-of-service'],
      ['Contact information', '/policies/contact-information', 'contact-information']
    ].forEach(function (item) {
      if (item[2] === policyKey) return;
      var link = element('a', 'policy-related__link', item[0]);
      link.href = item[1];
      relatedList.appendChild(link);
    });
    related.appendChild(relatedList);
    utility.append(help, related);
    mainColumn.appendChild(utility);

    contentInner.appendChild(mainColumn);
    contentSection.appendChild(contentInner);
    body.replaceChildren(contentSection);
  }

  ready(enhancePolicyPage);
}());
